import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

/**
 * Without the communication thread (MESSAGE_SYNCHRONIZATION) the section is a plain
 * message-history page, so the navigation label keeps its pre-thread name.
 */
export function getCommunicationSectionTitle() {
  return isFeatureEnabled(featureFlags.MESSAGE_SYNCHRONIZATION)
    ? i18n.t('page.customer.labels.communication')
    : i18n.t('general.labels.emailActivityLogs');
}
